
import Chat from 'components/ChatApp/Chat';
import { AppContext } from 'Utils/Contexts';
import React, { Component } from 'react'
import styles from "./Body.module.scss";
import AllConversation from './components/AllConversation/AllConversation';
import BodyHome from './components/BodyHome/BodyHome';


export default class Body extends Component {



    render() {
        return (
            <AppContext.Consumer>
                {appStateContext => (
                    <div className={styles.container}>
                        <BodyHome appState={appStateContext}></BodyHome>
                        <Chat></Chat>
                        <AllConversation></AllConversation>
                    </div>
                    
                )}
            </AppContext.Consumer>
        )
    }
}
